<script>
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import emitter from '@/modules/events/emitter'

export default defineComponent({
  name: 'ActiveCounter',
  computed: {
    ...mapGetters({
      drivers: 'statisticsModule/getDrivers',
      vehicles: 'statisticsModule/getVehicles',
      trailers: 'statisticsModule/getTrailers',
      errorsBag: 'statisticsModule/getErrorsBag'
    })
  },
  created () {
    this.getCounters()
    emitter.on('refreshed', this.getCounters)
  },
  methods: {
    getCounters () {
      this.$store.dispatch('statisticsModule/fetchDrivers')
      this.$store.dispatch('statisticsModule/fetchVehicles')
      this.$store.dispatch('statisticsModule/fetchTrailers')
    }
  }
})
</script>

<template>
  <div class="statistics-counters">
    <div class="alert alert-danger" v-if="errorsBag.length">
      {{ errorsBag[0] }}
    </div>
    <div class="text-primary"><i class="fa-solid fa-truck"></i> Aktywnych ciągników: <span class="fw-bolder">{{ vehicles.length }}</span></div>
    <div class="text-info"><i class="fa-solid fa-truck"></i> Aktywnych naczep: <span class="fw-bolder">{{ trailers.length }}</span></div>
    <div class="text-success"><i class="fa-solid fa-user"></i> Aktywnych kierowców: <span class="fw-bolder">{{ drivers.length }}</span></div>
  </div>
</template>

<style scoped>
.statistics-counters {
  font-size: 1.1rem;
  text-align: justify;
  text-transform: uppercase;
}

.statistics-counters .alert {
  font-size: .8rem;
}
</style>
